export default __webpack_public_path__ + "static/media/6.0c53f049.jpg";